export interface StoredUser {
    email: string;
    name: string;
    picture: string | null;
}

export const AUTH_STORAGE_EVENT = 'auth-storage-changed';

const ACCESS_TOKEN_KEY = 'accessToken';
const USER_KEY = 'user';

interface JwtPayload {
    exp?: number;
}

const notifyAuthStorageChanged = () => {
    window.dispatchEvent(new Event(AUTH_STORAGE_EVENT));
};

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const setAccessToken = (token: string) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    notifyAuthStorageChanged();
};

export const removeAccessToken = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    notifyAuthStorageChanged();
};

export const getStoredUser = (): StoredUser | null => {
    const storedUser = localStorage.getItem(USER_KEY);
    if (!storedUser) return null;

    try {
        return JSON.parse(storedUser) as StoredUser;
    } catch {
        localStorage.removeItem(USER_KEY);
        return null;
    }
};

export const setAuthStorage = (token: string, user: StoredUser) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    notifyAuthStorageChanged();
};

export const setStoredUser = (user: StoredUser) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    notifyAuthStorageChanged();
};

export const clearAuthStorage = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    notifyAuthStorageChanged();
};

export const isAccessTokenExpired = (token: string | null) => {
    if (!token) return true;

    try {
        const payloadBase64 = token.split('.')[1];
        if (!payloadBase64) return true;

        const normalizedPayload = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(window.atob(normalizedPayload)) as JwtPayload;

        if (!payload.exp) return true;

        return payload.exp * 1000 <= Date.now();
    } catch {
        return true;
    }
};
